import React, { Component } from 'react';
import DownArrow from '../common/DownArror';
import { Link as ScrollLink } from 'react-scroll';
import LazyLoad from 'react-lazyload';

export class Skills extends Component {
	state = {
		core: [
			{
				name: 'Javascript',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/js.png'
			},
			{
				name: 'HTML5',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/html5.png'
			},
			{
				name: 'CSS3',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/css.png'
			},
			{
				name: 'NODEJS',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1527873241/nodejs.png'
			},
			{
				name: 'PYHTON',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/python.png'
			},
			{
				name: 'SQL',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/sql1.png'
			},
			{
				name: 'MONGODB',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1527872819/mongodb.png'
			}
		],
		frameworks: [
			{
				name: 'REACT',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/react.png'
			},
			{
				name: 'GATSBY',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/gatsby.png'
			},
			{
				name: 'VUEJS',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/vue.png'
			},

			{
				name: 'EXPRESS',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,h_100/v1527875636/express.png'
			},

			{
				name: 'DJANGO',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1527875479/django.svg'
			},
			{
				name: 'BOOTSTRAP',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/bootstrap.png'
			},
			{
				name: 'JQUERY',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/v1527873503/jquery.png'
			},

			{
				name: 'FOUNDATION',
				icon: 'https://res.cloudinary.com/dydyt6wbt/image/upload/c_scale,w_100/v1527871272/foundation.png'
			}
		]
	};
	render() {
		return (
			<div id="skills" className="container">
				<div className="skills__container full-height  text-center">
					<div className="">
						<h3 className="section-title">Core Skills</h3>
						<ul className="skills__grid">
							{this.state.core.map((skill) => (
								<li key={skill.name} className="skills__item">
									<figure>
										<LazyLoad offset={200} height={100}>
											<img src={skill.icon} alt={skill.name} className="skills__image" />
										</LazyLoad>
										<figcaption>{skill.name}</figcaption>
									</figure>
								</li>
							))}
						</ul>
					</div>
					<div className="">
						<h3 className="section-title">Libraries & Frameworks</h3>
						<ul className="skills__grid">
							{this.state.frameworks.map((skill) => (
								<li key={skill.name} className="skills__item">
									<figure>
										<LazyLoad offset={200} height={100}>
											<img src={skill.icon} alt={skill.name} className="skills__image" />
										</LazyLoad>
										<figcaption>{skill.name}</figcaption>
									</figure>
								</li>
							))}
						</ul>
					</div>
					<div className="">
						<h3 className="section-title">Others</h3>
						<ul className="other-skills">
							<li>PROGRESSIVE WEB APPS</li>
							<li>SERVICE WORKERS</li>
							<li>RESPONSIVE DESIGN</li>
							<li>VERSION CONTROL</li>
							<li>TESTING</li>
						</ul>
					</div>
					<ScrollLink className="to-bottom skills__arrow" to="portfolio" smooth={true} duration={500}>
						<DownArrow />
					</ScrollLink>
				</div>
			</div>
		);
	}
}

export default Skills;



// WEBPACK FOOTER //
// ./src/components/containers/Skills.js